'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotConeIcon = function PlotConeIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 1360 1360' }, props),
        _react2.default.createElement('path', { fill: 'currentColor', d: 'M225.789 819.922l222.98-96.366-104.28-115.568zM560.889 447.017L773.026 328.73l-115.36-104.498zM652.143 812.807l232.156-71.453-91.035-126.252zM925.186 966.93l238.652-45.326-76.505-135.553zM294.912 1135.768l233.006-68.614-89.48-127.343zM928.172 538.308l236.041-57.275-83.24-131.544z' })
    );
};

exports.default = PlotConeIcon;